export default "__VITE_ASSET__fd4e4ec8__"